<template>
    <div class="reveal" :id="'deleteEntry'+ (typeof modalData == 'object' ? modalData.id : modalData )"  data-close-on-click="false" data-reveal="" :ref="'delete-modal-'+ (typeof modalData == 'object' ? modalData.id : modalData )">
        <h1> {{ this.title }} </h1>
        <hr>
        <hr class="invisible"><a class="button alert expanded" @click="handleDeleteClick">Delete this entry</a>
        <button class="close-button" data-close="" aria-label="Close modal" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2">
            <path d="M10 0a10 10 0 00-7.07 17.071c3.905 3.905 10.236 3.905 14.141 0 3.905-3.905 3.906-10.236 0-14.14A9.94 9.94 0 0010.002 0zm5.934 15.934c-3.27 3.27-8.592 3.27-11.866 0a8.39 8.39 0 1111.866 0z" fill="#161938" fill-rule="nonzero"></path>
            <path d="M13.91 6.07a.802.802 0 00-1.138 0L9.987 8.856l-2.94-2.942a.803.803 0 10-1.138 1.138L8.85 9.99l-2.941 2.942a.805.805 0 001.138 1.141l2.945-2.944 2.784 2.783a.816.816 0 001.138.004l.004-.004a.802.802 0 000-1.137l-2.784-2.784L13.926 7.2a.813.813 0 00-.016-1.13z" fill="#161938" fill-rule="nonzero"></path>
          </svg>
        </button>
    </div>
</template>
<script>
    import{blacktel} from '../../../config/pluginInit'
    export default {
        name: 'delete-confirmation',
        props: ['id', 'title', 'modalData'],
        beforeMount() {
            var id = '' ;
            if(typeof this.modalData == 'object') {
                id = this.modalData.id ;
            } else {
                id = this.modalData ;
            }
            var ele = window.$(`#deleteEntry` + id) ;
            if(ele.length ==1) {
                ele.detach();
            }
        },
        mounted () {
            var id = '' ;
            if(typeof this.modalData == 'object') {
                id = this.modalData.id ;
            } else {
                id = this.modalData ;
            }
            blacktel.foundationInit(window.$(`#deleteEntry` + id));
        },
        methods: {
            handleDeleteClick: function () {
                this.$emit('clicked', this.modalData)
            },
        },
    }
</script>
